<script>
import Highcharts from '@@/common/stats/Highcharts';
import lang from '@/mixins/lang';
import { deepMerge } from '@/utils/object';
import { format as formatNumber } from '@/utils/number';

// TODO: move this to UI directory as BaseChart if the design is used in other places
export default {
  name: 'AdvertisementLineChart',
  components: { Highcharts },
  mixins: [lang],
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    baseConfig() {
      const isPersian = this.lang === 'fa';
      const align = isPersian ? 'right' : 'left';
      const font = isPersian ? 'IRANSans' : 'EnIRANSans';

      return {
        chart: {
          type: 'spline',
          style: {
            fontFamily: font,
          },
        },
        plotOptions: {
          series: {
            marker: { enabled: false },
          },
        },
        title: { text: null },
        tooltip: {
          shared: false,
          useHTML: true,
          shadow: true,
          borderWidth: 0,
          borderRadius: 12,
          backgroundColor: '#fff',
          style: { color: '#000', textAlign: align },
          headerFormat: '<span>{point.key}</span>',
          pointFormatter() {
            return `
              <div>
                <b style="color:${this.color}">${this.series.name}:</b>
                <b>${formatNumber(Math.round(this.y))}</b>
              </div>`;
          },
        },
        legend: {
          rtl: isPersian,
        },
        xAxis: {
          tickInterval: 1,
          gridLineWidth: 1,
          gridLineDashStyle: 'dash',
        },
        credits: { enabled: false },
        legend: { enabled: false },
      };
    },
    mergedConfig() {
      return deepMerge(this.baseConfig, this.config);
    },
  },
};
</script>

<template>
  <Highcharts
    ref="chart"
    v-bind="$attrs"
    :options="mergedConfig"
    v-on="$listeners"
  />
</template>
